import { Component, OnInit, Input } from '@angular/core';
import { OrderDetailsBillingObject } from 'src/app/models/orders/order-details-billing/order-details-billing-object.model';
import { BillingOffersObject } from 'src/app/models/orders/order-details-billing/billing-offers/billing-offers-object.model';
import { BillingOffersService } from 'src/app/services/api/billing/obtain-order-billing-offers.service';
import { ActivatedRoute } from '@angular/router';
import { BillingInventoryResponse } from 'src/app/models/orders/order-details-billing/billing-inventory-response';

@Component({
  selector: 'app-billing-info',
  templateUrl: './billing-info.component.html',
  styleUrls: ['./billing-info.component.css']
})
export class BillingInfoComponent implements OnInit {

  offersList: Array<BillingOffersObject>;
  billing: OrderDetailsBillingObject;
  offersListSize: number;
  billingDate: string;
  billingDateObject: Date;
  @Input() orderId: string;
  @Input() editable: boolean;

  constructor(private activatedRoute: ActivatedRoute, private billingOffersService: BillingOffersService) {

  }

  ngOnInit() {

    this.billing = new OrderDetailsBillingObject(null, null, new Array<BillingOffersObject>());

    this.billingOffersService.getOffersList(this.orderId).then((val: BillingInventoryResponse) => {
      this.billingDate = val.getBillingDate();
      this.billingDateObject = val.getBillingDate() != null ? new Date(val.getBillingDate()) : null;
      this.offersList = val.getOffersList();
      this.offersListSize = this.offersList.length;
      this.billing = new OrderDetailsBillingObject(this.billingDate, 0, this.offersList);

    }).catch(error => {
      console.error(error);
      this.offersList = new Array<BillingOffersObject>();
      this.billing = new OrderDetailsBillingObject(null, null, new Array<BillingOffersObject>());
      this.offersListSize = 0;
      this.billingDate = null;
      this.billingDateObject = null;
    });
  }

  public getBillingDate(): string {
    return this.billingDate != null ? this.billingDate : 'ninguna';
  }

  onDateChange($event) {
    this.billingOffersService.updateBillingDate(this.orderId, $event).then().catch(error => {
      console.error(error);
    });
  }
}
